import { render } from "./DashboardSidebar.vue?vue&type=template&id=63ec99ca"
import script from "./DashboardSidebar.vue?vue&type=script&lang=js"
export * from "./DashboardSidebar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__